export const COUNTRY_LIST = [
	{ code: 'AF', flag: 'assets/media/flags/afghanistan.svg', name: 'Afghanistan' },
	{ code: 'AX', flag: 'assets/media/flags/aland-islands.svg', name: 'Aland Islands' },
	{ code: 'AL', flag: 'assets/media/flags/albania.svg', name: 'Albania' },
	{ code: 'DZ', flag: 'assets/media/flags/algeria.svg', name: 'Algeria' },
	{ code: 'AS', flag: 'assets/media/flags/american-samoa.svg', name: 'American Samoa' },
	{ code: 'AD', flag: 'assets/media/flags/andorra.svg', name: 'Andorra' },
	{ code: 'AO', flag: 'assets/media/flags/angola.svg', name: 'Angola' },
	{ code: 'AI', flag: 'assets/media/flags/anguilla.svg', name: 'Anguilla' },
	{ code: 'AG', flag: 'assets/media/flags/antigua-and-barbuda.svg', name: 'Antigua and Barbuda' },
	{ code: 'AR', flag: 'assets/media/flags/argentina.svg', name: 'Argentina' },
	{ code: 'AM', flag: 'assets/media/flags/armenia.svg', name: 'Armenia' },
	{ code: 'AW', flag: 'assets/media/flags/aruba.svg', name: 'Aruba' },
	{ code: 'AU', flag: 'assets/media/flags/australia.svg', name: 'Australia' },
	{ code: 'AT', flag: 'assets/media/flags/austria.svg', name: 'Austria' },
	{ code: 'AZ', flag: 'assets/media/flags/azerbaijan.svg', name: 'Azerbaijan' },
	{ code: 'BS', flag: 'assets/media/flags/bahamas.svg', name: 'Bahamas' },
	{ code: 'BH', flag: 'assets/media/flags/bahrain.svg', name: 'Bahrain' },
	{ code: 'BD', flag: 'assets/media/flags/bangladesh.svg', name: 'Bangladesh' },
	{ code: 'BB', flag: 'assets/media/flags/barbados.svg', name: 'Barbados' },
	{ code: 'BY', flag: 'assets/media/flags/belarus.svg', name: 'Belarus' },
	{ code: 'BE', flag: 'assets/media/flags/belgium.svg', name: 'Belgium' },
	{ code: 'BZ', flag: 'assets/media/flags/belize.svg', name: 'Belize' },
	{ code: 'BJ', flag: 'assets/media/flags/benin.svg', name: 'Benin' },
	{ code: 'BM', flag: 'assets/media/flags/bermuda.svg', name: 'Bermuda' },
	{ code: 'BT', flag: 'assets/media/flags/bhutan.svg', name: 'Bhutan' },
	{ code: 'BO', flag: 'assets/media/flags/bolivia.svg', name: 'Bolivia, Plurinational State of' },
	{ code: 'BQ', flag: 'assets/media/flags/bonaire.svg', name: 'Bonaire, Sint Eustatius and Saba' },
	{ code: 'BA', flag: 'assets/media/flags/bosnia-and-herzegovina.svg', name: 'Bosnia and Herzegovina' },
	{ code: 'BW', flag: 'assets/media/flags/botswana.svg', name: 'Botswana' },
	{ code: 'BR', flag: 'assets/media/flags/brazil.svg', name: 'Brazil' },
	{ code: 'IO', flag: 'assets/media/flags/british-indian-ocean-territory.svg', name: 'British Indian Ocean Territory' },
	{ code: 'BN', flag: 'assets/media/flags/brunei.svg', name: 'Brunei Darussalam' },
	{ code: 'BG', flag: 'assets/media/flags/bulgaria.svg', name: 'Bulgaria' },
	{ code: 'BF', flag: 'assets/media/flags/burkina-faso.svg', name: 'Burkina Faso' },
	{ code: 'BI', flag: 'assets/media/flags/burundi.svg', name: 'Burundi' },
	{ code: 'KH', flag: 'assets/media/flags/cambodia.svg', name: 'Cambodia' },
	{ code: 'CM', flag: 'assets/media/flags/cameroon.svg', name: 'Cameroon' },
	{ code: 'CA', flag: 'assets/media/flags/canada.svg', name: 'Canada' },
	{ code: 'CV', flag: 'assets/media/flags/cape-verde.svg', name: 'Cape Verde' },
	{ code: 'KY', flag: 'assets/media/flags/cayman-islands.svg', name: 'Cayman Islands' },
	{ code: 'CF', flag: 'assets/media/flags/central-african-republic.svg', name: 'Central African Republic' },
	{ code: 'TD', flag: 'assets/media/flags/chad.svg', name: 'Chad' },
	{ code: 'CL', flag: 'assets/media/flags/chile.svg', name: 'Chile' },
	{ code: 'CN', flag: 'assets/media/flags/china.svg', name: 'China' },
	{ code: 'CX', flag: 'assets/media/flags/christmas-island.svg', name: 'Christmas Island' },
	{ code: 'CC', flag: 'assets/media/flags/cocos-island.svg', name: 'Cocos (Keeling) Islands' },
	{ code: 'CO', flag: 'assets/media/flags/colombia.svg', name: 'Colombia' },
	{ code: 'KM', flag: 'assets/media/flags/comoros.svg', name: 'Comoros' },
	{ code: 'CK', flag: 'assets/media/flags/cook-islands.svg', name: 'Cook Islands' },
	{ code: 'CR', flag: 'assets/media/flags/costa-rica.svg', name: 'Costa Rica' },
	{ code: 'CI', flag: 'assets/media/flags/ivory-coast.svg', name: 'Côte dIvoire' },
	{ code: 'HR', flag: 'assets/media/flags/croatia.svg', name: 'Croatia' },
	{ code: 'CU', flag: 'assets/media/flags/cuba.svg', name: 'Cuba' },
	{ code: 'CW', flag: 'assets/media/flags/curacao.svg', name: 'Curaçao' },
	{ code: 'CZ', flag: 'assets/media/flags/czech-republic.svg', name: 'Czech Republic' },
	{ code: 'DK', flag: 'assets/media/flags/denmark.svg', name: 'Denmark' },
	{ code: 'DJ', flag: 'assets/media/flags/djibouti.svg', name: 'Djibouti' },
	{ code: 'DM', flag: 'assets/media/flags/dominica.svg', name: 'Dominica' },
	{ code: 'DO', flag: 'assets/media/flags/dominican-republic.svg', name: 'Dominican Republic' },
	{ code: 'EC', flag: 'assets/media/flags/ecuador.svg', name: 'Ecuador' },
	{ code: 'EG', flag: 'assets/media/flags/egypt.svg', name: 'Egypt' },
	{ code: 'SV', flag: 'assets/media/flags/el-salvador.svg', name: 'El Salvador' },
	{ code: 'GQ', flag: 'assets/media/flags/equatorial-guinea.svg', name: 'Equatorial Guinea' },
	{ code: 'ER', flag: 'assets/media/flags/eritrea.svg', name: 'Eritrea' },
	{ code: 'EE', flag: 'assets/media/flags/estonia.svg', name: 'Estonia' },
	{ code: 'ET', flag: 'assets/media/flags/ethiopia.svg', name: 'Ethiopia' },
	{ code: 'FK', flag: 'assets/media/flags/falkland-islands.svg', name: 'Falkland Islands (Malvinas)' },
	{ code: 'FJ', flag: 'assets/media/flags/fiji.svg', name: 'Fiji' },
	{ code: 'FI', flag: 'assets/media/flags/finland.svg', name: 'Finland' },
	{ code: 'FR', flag: 'assets/media/flags/france.svg', name: 'France' },
	{ code: 'PF', flag: 'assets/media/flags/french-polynesia.svg', name: 'French Polynesia' },
	{ code: 'GA', flag: 'assets/media/flags/gabon.svg', name: 'Gabon' },
	{ code: 'GM', flag: 'assets/media/flags/gambia.svg', name: 'Gambia' },
	{ code: 'GE', flag: 'assets/media/flags/georgia.svg', name: 'Georgia' },
	{ code: 'DE', flag: 'assets/media/flags/germany.svg', name: 'Germany' },
	{ code: 'GH', flag: 'assets/media/flags/ghana.svg', name: 'Ghana' },
	{ code: 'GI', flag: 'assets/media/flags/gibraltar.svg', name: 'Gibraltar' },
	{ code: 'GR', flag: 'assets/media/flags/greece.svg', name: 'Greece' },
	{ code: 'GL', flag: 'assets/media/flags/greenland.svg', name: 'Greenland' },
	{ code: 'GD', flag: 'assets/media/flags/grenada.svg', name: 'Grenada' },
	{ code: 'GU', flag: 'assets/media/flags/guam.svg', name: 'Guam' },
	{ code: 'GT', flag: 'assets/media/flags/guatemala.svg', name: 'Guatemala' },
	{ code: 'GG', flag: 'assets/media/flags/guernsey.svg', name: 'Guernsey' },
	{ code: 'GN', flag: 'assets/media/flags/guinea.svg', name: 'Guinea' },
	{ code: 'GW', flag: 'assets/media/flags/guinea-bissau.svg', name: 'Guinea-Bissau' },
	{ code: 'HT', flag: 'assets/media/flags/haiti.svg', name: 'Haiti' },
	{ code: 'VA', flag: 'assets/media/flags/vatican-city.svg', name: 'Holy See (Vatican City State)' },
	{ code: 'HN', flag: 'assets/media/flags/honduras.svg', name: 'Honduras' },
	{ code: 'HK', flag: 'assets/media/flags/hong-kong.svg', name: 'Hong Kong' },
	{ code: 'HU', flag: 'assets/media/flags/hungary.svg', name: 'Hungary' },
	{ code: 'IS', flag: 'assets/media/flags/iceland.svg', name: 'Iceland' },
	{ code: 'IN', flag: 'assets/media/flags/india.svg', name: 'India' },
	{ code: 'ID', flag: 'assets/media/flags/indonesia.svg', name: 'Indonesia' },
	{ code: 'IR', flag: 'assets/media/flags/iran.svg', name: 'Iran, Islamic Republic of' },
	{ code: 'IQ', flag: 'assets/media/flags/iraq.svg', name: 'Iraq' },
	{ code: 'IE', flag: 'assets/media/flags/ireland.svg', name: 'Ireland' },
	{ code: 'IM', flag: 'assets/media/flags/isle-of-man.svg', name: 'Isle of Man' },
	{ code: 'IL', flag: 'assets/media/flags/israel.svg', name: 'Israel' },
	{ code: 'IT', flag: 'assets/media/flags/italy.svg', name: 'Italy' },
	{ code: 'JM', flag: 'assets/media/flags/jamaica.svg', name: 'Jamaica' },
	{ code: 'JP', flag: 'assets/media/flags/japan.svg', name: 'Japan' },
	{ code: 'JE', flag: 'assets/media/flags/jersey.svg', name: 'Jersey' },
	{ code: 'JO', flag: 'assets/media/flags/jordan.svg', name: 'Jordan' },
	{ code: 'KZ', flag: 'assets/media/flags/kazakhstan.svg', name: 'Kazakhstan' },
	{ code: 'KE', flag: 'assets/media/flags/kenya.svg', name: 'Kenya' },
	{ code: 'KI', flag: 'assets/media/flags/kiribati.svg', name: 'Kiribati' },
	{ code: 'KP', flag: 'assets/media/flags/north-korea.svg', name: 'Korea, Democratic Peoples Republic of' },
	{ code: 'KW', flag: 'assets/media/flags/kuwait.svg', name: 'Kuwait' },
	{ code: 'KG', flag: 'assets/media/flags/kyrgyzstan.svg', name: 'Kyrgyzstan' },
	{ code: 'LA', flag: 'assets/media/flags/laos.svg', name: 'Lao Peoples Democratic Republic' },
	{ code: 'LV', flag: 'assets/media/flags/latvia.svg', name: 'Latvia' },
	{ code: 'LB', flag: 'assets/media/flags/lebanon.svg', name: 'Lebanon' },
	{ code: 'LS', flag: 'assets/media/flags/lesotho.svg', name: 'Lesotho' },
	{ code: 'LR', flag: 'assets/media/flags/liberia.svg', name: 'Liberia' },
	{ code: 'LY', flag: 'assets/media/flags/libya.svg', name: 'Libya' },
	{ code: 'LI', flag: 'assets/media/flags/liechtenstein.svg', name: 'Liechtenstein' },
	{ code: 'LT', flag: 'assets/media/flags/lithuania.svg', name: 'Lithuania' },
	{ code: 'LU', flag: 'assets/media/flags/luxembourg.svg', name: 'Luxembourg' },
	{ code: 'MO', flag: 'assets/media/flags/macao.svg', name: 'Macao' },
	{ code: 'MG', flag: 'assets/media/flags/madagascar.svg', name: 'Madagascar' },
	{ code: 'MW', flag: 'assets/media/flags/malawi.svg', name: 'Malawi' },
	{ code: 'MY', flag: 'assets/media/flags/malaysia.svg', name: 'Malaysia' },
	{ code: 'MV', flag: 'assets/media/flags/maldives.svg', name: 'Maldives' },
	{ code: 'ML', flag: 'assets/media/flags/mali.svg', name: 'Mali' },
	{ code: 'MT', flag: 'assets/media/flags/malta.svg', name: 'Malta' },
	{ code: 'MH', flag: 'assets/media/flags/marshall-island.svg', name: 'Marshall Islands' },
	{ code: 'MQ', flag: 'assets/media/flags/martinique.svg', name: 'Martinique' },
	{ code: 'MR', flag: 'assets/media/flags/mauritania.svg', name: 'Mauritania' },
	{ code: 'MU', flag: 'assets/media/flags/mauritius.svg', name: 'Mauritius' },
	{ code: 'MX', flag: 'assets/media/flags/mexico.svg', name: 'Mexico' },
	{ code: 'FM', flag: 'assets/media/flags/micronesia.svg', name: 'Micronesia, Federated States of' },
	{ code: 'MD', flag: 'assets/media/flags/moldova.svg', name: 'Moldova, Republic of' },
	{ code: 'MC', flag: 'assets/media/flags/monaco.svg', name: 'Monaco' },
	{ code: 'MN', flag: 'assets/media/flags/mongolia.svg', name: 'Mongolia' },
	{ code: 'ME', flag: 'assets/media/flags/montenegro.svg', name: 'Montenegro' },
	{ code: 'MS', flag: 'assets/media/flags/montserrat.svg', name: 'Montserrat' },
	{ code: 'MA', flag: 'assets/media/flags/morocco.svg', name: 'Morocco' },
	{ code: 'MZ', flag: 'assets/media/flags/mozambique.svg', name: 'Mozambique' },
	{ code: 'MM', flag: 'assets/media/flags/myanmar.svg', name: 'Myanmar' },
	{ code: 'NA', flag: 'assets/media/flags/namibia.svg', name: 'Namibia' },
	{ code: 'NR', flag: 'assets/media/flags/nauru.svg', name: 'Nauru' },
	{ code: 'NP', flag: 'assets/media/flags/nepal.svg', name: 'Nepal' },
	{ code: 'NL', flag: 'assets/media/flags/netherlands.svg', name: 'Netherlands' },
	{ code: 'NZ', flag: 'assets/media/flags/new-zealand.svg', name: 'New Zealand' },
	{ code: 'NI', flag: 'assets/media/flags/nicaragua.svg', name: 'Nicaragua' },
	{ code: 'NE', flag: 'assets/media/flags/niger.svg', name: 'Niger' },
	{ code: 'NG', flag: 'assets/media/flags/nigeria.svg', name: 'Nigeria' },
	{ code: 'NU', flag: 'assets/media/flags/niue.svg', name: 'Niue' },
	{ code: 'NF', flag: 'assets/media/flags/norfolk-island.svg', name: 'Norfolk Island' },
	{ code: 'MP', flag: 'assets/media/flags/northern-mariana-islands.svg', name: 'Northern Mariana Islands' },
	{ code: 'NO', flag: 'assets/media/flags/norway.svg', name: 'Norway' },
	{ code: 'OM', flag: 'assets/media/flags/oman.svg', name: 'Oman' },
	{ code: 'PK', flag: 'assets/media/flags/pakistan.svg', name: 'Pakistan' },
	{ code: 'PW', flag: 'assets/media/flags/palau.svg', name: 'Palau' },
	{ code: 'PS', flag: 'assets/media/flags/palestine.svg', name: 'Palestinian Territory, Occupied' },
	{ code: 'PA', flag: 'assets/media/flags/panama.svg', name: 'Panama' },
	{ code: 'PG', flag: 'assets/media/flags/papua-new-guinea.svg', name: 'Papua New Guinea' },
	{ code: 'PY', flag: 'assets/media/flags/paraguay.svg', name: 'Paraguay' },
	{ code: 'PE', flag: 'assets/media/flags/peru.svg', name: 'Peru' },
	{ code: 'PH', flag: 'assets/media/flags/philippines.svg', name: 'Philippines' },
	{ code: 'PL', flag: 'assets/media/flags/poland.svg', name: 'Poland' },
	{ code: 'PT', flag: 'assets/media/flags/portugal.svg', name: 'Portugal' },
	{ code: 'PR', flag: 'assets/media/flags/puerto-rico.svg', name: 'Puerto Rico' },
	{ code: 'QA', flag: 'assets/media/flags/qatar.svg', name: 'Qatar' },
	{ code: 'RO', flag: 'assets/media/flags/romania.svg', name: 'Romania' },
	{ code: 'RU', flag: 'assets/media/flags/russia.svg', name: 'Russian Federation' },
	{ code: 'RW', flag: 'assets/media/flags/rwanda.svg', name: 'Rwanda' },
	{ code: 'BL', flag: 'assets/media/flags/st-barts.svg', name: 'Saint Barthélemy' },
	{ code: 'KN', flag: 'assets/media/flags/saint-kitts-and-nevis.svg', name: 'Saint Kitts and Nevis' },
	{ code: 'LC', flag: 'assets/media/flags/st-lucia.svg', name: 'Saint Lucia' },
	{ code: 'MF', flag: 'assets/media/flags/sint-maarten.svg', name: 'Saint Martin (French part)' },
	{ code: 'VC', flag: 'assets/media/flags/st-vincent-and-the-grenadines.svg', name: 'Saint Vincent and the Grenadines' },
	{ code: 'WS', flag: 'assets/media/flags/samoa.svg', name: 'Samoa' },
	{ code: 'SM', flag: 'assets/media/flags/san-marino.svg', name: 'San Marino' },
	{ code: 'ST', flag: 'assets/media/flags/sao-tome-and-prince.svg', name: 'Sao Tome and Principe' },
	{ code: 'SA', flag: 'assets/media/flags/saudi-arabia.svg', name: 'Saudi Arabia' },
	{ code: 'SN', flag: 'assets/media/flags/senegal.svg', name: 'Senegal' },
	{ code: 'RS', flag: 'assets/media/flags/serbia.svg', name: 'Serbia' },
	{ code: 'SC', flag: 'assets/media/flags/seychelles.svg', name: 'Seychelles' },
	{ code: 'SL', flag: 'assets/media/flags/sierra-leone.svg', name: 'Sierra Leone' },
	{ code: 'SG', flag: 'assets/media/flags/singapore.svg', name: 'Singapore' },
	{ code: 'SX', flag: 'assets/media/flags/sint-maarten.svg', name: 'Sint Maarten (Dutch part)' },
	{ code: 'SK', flag: 'assets/media/flags/slovakia.svg', name: 'Slovakia' },
	{ code: 'SI', flag: 'assets/media/flags/slovenia.svg', name: 'Slovenia' },
	{ code: 'SB', flag: 'assets/media/flags/solomon-islands.svg', name: 'Solomon Islands' },
	{ code: 'SO', flag: 'assets/media/flags/somalia.svg', name: 'Somalia' },
	{ code: 'ZA', flag: 'assets/media/flags/south-africa.svg', name: 'South Africa' },
	{ code: 'KR', flag: 'assets/media/flags/south-korea.svg', name: 'South Korea' },
	{ code: 'SS', flag: 'assets/media/flags/south-sudan.svg', name: 'South Sudan' },
	{ code: 'ES', flag: 'assets/media/flags/spain.svg', name: 'Spain' },
	{ code: 'LK', flag: 'assets/media/flags/sri-lanka.svg', name: 'Sri Lanka' },
	{ code: 'SD', flag: 'assets/media/flags/sudan.svg', name: 'Sudan' },
	{ code: 'SR', flag: 'assets/media/flags/suriname.svg', name: 'Suriname' },
	{ code: 'SZ', flag: 'assets/media/flags/swaziland.svg', name: 'Swaziland' },
	{ code: 'SE', flag: 'assets/media/flags/sweden.svg', name: 'Sweden' },
	{ code: 'CH', flag: 'assets/media/flags/switzerland.svg', name: 'Switzerland' },
	{ code: 'SY', flag: 'assets/media/flags/syria.svg', name: 'Syrian Arab Republic' },
	{ code: 'TW', flag: 'assets/media/flags/taiwan.svg', name: 'Taiwan, Province of China' },
	{ code: 'TJ', flag: 'assets/media/flags/tajikistan.svg', name: 'Tajikistan' },
	{ code: 'TZ', flag: 'assets/media/flags/tanzania.svg', name: 'Tanzania, United Republic of' },
	{ code: 'TH', flag: 'assets/media/flags/thailand.svg', name: 'Thailand' },
	{ code: 'TG', flag: 'assets/media/flags/togo.svg', name: 'Togo' },
	{ code: 'TK', flag: 'assets/media/flags/tokelau.svg', name: 'Tokelau' },
	{ code: 'TO', flag: 'assets/media/flags/tonga.svg', name: 'Tonga' },
	{ code: 'TT', flag: 'assets/media/flags/trinidad-and-tobago.svg', name: 'Trinidad and Tobago' },
	{ code: 'TN', flag: 'assets/media/flags/tunisia.svg', name: 'Tunisia' },
	{ code: 'TR', flag: 'assets/media/flags/turkey.svg', name: 'Turkey' },
	{ code: 'TM', flag: 'assets/media/flags/turkmenistan.svg', name: 'Turkmenistan' },
	{ code: 'TC', flag: 'assets/media/flags/turks-and-caicos.svg', name: 'Turks and Caicos Islands' },
	{ code: 'TV', flag: 'assets/media/flags/tuvalu.svg', name: 'Tuvalu' },
	{ code: 'UG', flag: 'assets/media/flags/uganda.svg', name: 'Uganda' },
	{ code: 'UA', flag: 'assets/media/flags/ukraine.svg', name: 'Ukraine' },
	{ code: 'AE', flag: 'assets/media/flags/united-arab-emirates.svg', name: 'United Arab Emirates' },
	{ code: 'GB', flag: 'assets/media/flags/united-kingdom.svg', name: 'United Kingdom' },
	{ code: 'US', flag: 'assets/media/flags/united-states.svg', name: 'United States' },
	{ code: 'UY', flag: 'assets/media/flags/uruguay.svg', name: 'Uruguay' },
	{ code: 'UZ', flag: 'assets/media/flags/uzbekistan.svg', name: 'Uzbekistan' },
	{ code: 'VU', flag: 'assets/media/flags/vanuatu.svg', name: 'Vanuatu' },
	{ code: 'VE', flag: 'assets/media/flags/venezuela.svg', name: 'Venezuela, Bolivarian Republic of' },
	{ code: 'VN', flag: 'assets/media/flags/vietnam.svg', name: 'Vietnam' },
	{ code: 'VI', flag: 'assets/media/flags/virgin-islands.svg', name: 'Virgin Islands' },
	{ code: 'YE', flag: 'assets/media/flags/yemen.svg', name: 'Yemen' },
	{ code: 'ZM', flag: 'assets/media/flags/zambia.svg', name: 'Zambia' },
	{ code: 'ZW', flag: 'assets/media/flags/zimbabwe.svg', name: 'Zimbabwe' },
];